import { store } from 'store';
import { AsyncAction } from 'models';
import { actions as SettingsActions } from './reducer';
import { actions as AppActions } from '../app/reducer';
import { batch } from 'react-redux';
import { createTranslationsConfig } from 'utils';
import _get from 'lodash/get';
import { keysList } from 'configs/keys-list';

import axios from 'axios';
import services from 'services';

import i18next from 'i18next';

export const logout = (warningMessage?: string): AsyncAction => {
  return async (dispatch) => {
    try {
      dispatch(AppActions.setLoggingOutStatus(true));

      const { Data } = (await services.get('/logout')).data;
      await axios.get(Data, { withCredentials: true });
    } catch (err) {
      console.error(err);
      dispatch(AppActions.setLoggingOutStatus(false));
    } finally {
      batch(() => {
        dispatch(SettingsActions.resetAuthorizationSettings());
        dispatch(AppActions.logout(warningMessage));
      });
    }
  };
};

async function initTranslations() {
  const serverTranslations: Array<{ Id: string; String: string }> = (
    await axios.post('/api/localization?all=true', keysList)
  ).data.Data;
  const config = createTranslationsConfig(serverTranslations);
  i18next.addResourceBundle('fi', 'translation', config, true, true);
}

async function getAuthorizationSettings(q: URLSearchParams) {
  if (q.has('code')) {
    let code = q.get('code');

    const { data } = await services.post('/token', { code });

    let tokens = JSON.parse(data);
    let payload: Record<string, any> = {
      expires_in_start: null,
      expires_in: null,
      access_token: null,
      token_type: null,
      refresh_token: null,
    };

    for (let key in tokens) {
      if (key === 'access_token') {
        payload['expires_in_start'] = Math.floor(Date.now() / 1000);
      }

      payload[key] = tokens[key];
    }

    return payload;
  }
}

export async function refreshToken() {
  try {
    const { refresh_token } = store.getState().settings;

    if (!refresh_token) {
      store.dispatch(AppActions.logout());
      return;
    }

    const { data } = await axios.post(`/token/refresh`, {
      refreshToken: refresh_token,
    });

    let tokens = JSON.parse(data);

    if (_get(tokens, 'error') === 'invalid_grant') {
      store.dispatch(
        AppActions.logout(
          'Istunto on vanhentunut! Ole hyvä ja kirjaudu sisään uudelleen.'
        )
      );
      return;
    }

    let token;
    let payload: Record<string, any> = {
      expires_in_start: null,
      expires_in: null,
      access_token: null,
      token_type: null,
    };

    for (let key in tokens) {
      if (key === 'access_token') {
        payload['expires_in_start'] = Math.floor(Date.now() / 1000);
        token = tokens[key];
      }

      payload[key] = tokens[key];
    }

    store.dispatch(SettingsActions.setAuthorizationSettings(payload));
    return token;
  } catch (err) {
    console.error(err);
  }
}

export const initialize = (q: URLSearchParams): AsyncAction => {
  return async (dispatch, getState) => {
    dispatch(AppActions.setLoadingState(true));
    try {
      if (q.has('code')) {
        const authorizationSettings = await getAuthorizationSettings(q);

        dispatch(
          SettingsActions.setAuthorizationSettings(authorizationSettings)
        );

        window.history.replaceState(
          {},
          document.title,
          window.location.pathname
        );
      }

      await initTranslations();

      const { access_token } = getState().settings;

      if (access_token) {
        const { data: isLogIn } = await services.post('/login/check');

        if (isLogIn) {
          const { SubPortals, UserSettings, ApplicationConfiguration } = (
            await services.get('/api/user/initializationconfiguration')
          ).data.Data;

          batch(() => {
            dispatch(
              AppActions.setInsturctions({
                portals: SubPortals,
                userSettings: UserSettings.length ? UserSettings[0] : null,
                privacyPolicy:
                  ApplicationConfiguration?.PrivacyPolicyUrl || null,
                repairInstruction:
                  ApplicationConfiguration?.CaseRepairInstructionUrl || null,
                repairInstructionEng:
                  ApplicationConfiguration?.CaseRepairInstructionEngUrl ?? null,
                logoURL: ApplicationConfiguration?.LogoUrl || null,
              })
            );

            if (
              SubPortals &&
              Array.isArray(SubPortals) &&
              SubPortals.length === 1
            ) {
              const [portal] = SubPortals;

              if (portal) {
                dispatch(SettingsActions.setPortal(portal));
              }
            }
          });
        } else {
          batch(() => {
            dispatch(AppActions.setLoginState(false));
            dispatch(SettingsActions.resetAuthorizationSettings());
            dispatch(AppActions.setLoadingState(false));
          });
        }

        // dispatch(setTranslations(config));
        dispatch(AppActions.setLoadingState(false));
      } else {
        dispatch(AppActions.setLoadingState(false));
      }
    } catch (err) {
      console.error(err);
      dispatch(AppActions.setLoadingState(false));
    }
  };
};
